import { z } from 'zod';
export const searchQuerySchema = z.string().trim().min(2).max(200);
export const onboardingSchema = z.object({
    step: z.number().int().min(0).max(2),
    title: z.string().trim().min(1).max(200).optional(),
    skip: z.boolean().default(false),
});
//# sourceMappingURL=discovery.js.map